import { List, Map } from 'immutable';
import { call } from 'redux-saga/effects';
import { IGetObjectContextRequest } from '../../entities';
import {
	ServiceList,
	GenerateDmData,
	DmObjectType,
	DmData,
	DmDataPermissionsFactory,
	DmDataPermissionsFactoryFromJS,
	DmObjectPropertiesFactoryFromJS,
	MainUtils
} from '@bimser/common';
import _upperFirst from 'lodash/upperFirst';

export function* callGetObjectContext(
	dmObjects: Map<string, DmData>,
	excludeItems: IGetObjectContextRequest = {},
	force: boolean = false
) {
	const dmDataArray = dmObjects
		.valueSeq()
		.toArray()
		.filter(x => !x.id.includes('#'));
	const notLoaded = dmDataArray.filter(object => {
		const keys = Object.keys(object.contextLoaded.toJS()).filter(
			x => !(excludeItems as any)['Exclude' + _upperFirst(x)]
		);
		return !keys.map(x => (object.contextLoaded as any)[x]).every(Boolean);
	});
	const shortcuts = dmDataArray.filter(object => object.type == DmObjectType.Shortcut);
	//let dmObject: IDmData = getDataObjectFactory(yield select(), object.id);
	if (notLoaded.length == 0 && !force) {
		return dmObjects;
	}

	const requestDataPayload: IGetObjectContextRequest = {
		secretKeys: (force ? dmDataArray : notLoaded).map(data => data.secretKey),
		includeMetadataCaption: !excludeItems?.ExcludeProperties,
		...excludeItems
	};

	const deletedShortcuts = [];

	if (shortcuts.length && !excludeItems.ExcludePermissions) {
		for (const object of shortcuts) {
			const res =
				yield ServiceList.dm.DocumentManagement.Explorer.CheckDocumentExistAndAuthorize.call(
					{ secretKey: object.secretKey },
					null,
					null,
					true
				);

			if (!res) {
				dmObjects = dmObjects.set(
					object.id,
					object
						.setIn(['contextLoaded', 'permissions'], true)
						.setIn(['permissions', 'deleteShortcut'], true)
				);
				deletedShortcuts.push(object.secretKey);
			}
		}

		if (deletedShortcuts.length) {
			requestDataPayload.secretKeys = (requestDataPayload.secretKeys as string[]).filter(
				x => !deletedShortcuts.includes(x)
			);
		}
	}

	const data = yield ServiceList.dm.DocumentManagement.Explorer.GetObjectsContext.handleError(
		MainUtils.customErrorHandle
	).call(requestDataPayload, null, null, true);
	if (data) {
		for (const key in dmObjects.toJS()) {
			dmObjects = dmObjects.set(
				key,
				yield call(setObjectPermissions, dmObjects.get(key), excludeItems, data)
			);
		}
	}

	return dmObjects;
}

function* setObjectPermissions(
	object: DmData,
	excludeItems: IGetObjectContextRequest,
	responseData: any
) {
	const { permissions, parentTrees, properties } = responseData;
	const objectId = object.id;
	if (!excludeItems.ExcludePermissions && permissions[objectId]) {
		object = object
			.setIn(['contextLoaded', 'permissions'], true)
			.set('permissions', DmDataPermissionsFactoryFromJS(permissions[objectId]));
	} else if (!object.permissions) {
		object = object.set('permissions', DmDataPermissionsFactory());
	}

	if (!excludeItems.ExcludeProperties && properties[objectId]) {
		object = object
			.setIn(['contextLoaded', 'properties'], true)
			.set('properties', DmObjectPropertiesFactoryFromJS(properties[objectId]));
	}

	if (!excludeItems.ExcludeParentTrees && parentTrees[objectId]) {
		for (let index = 0; index < parentTrees[objectId].length; index++) {
			const i = parentTrees[objectId][index];
			parentTrees[objectId][index] = yield call(GenerateDmData, i);
		}

		object = object
			.setIn(['contextLoaded', 'parentTrees'], true)
			.set('parents', List(parentTrees[objectId]));
	}

	return object;
}
